<template>
    <section class="section">

        <h1 class="title has-text-centered">
            Mot de passe oublié
        </h1>

        <div class="field">
            <label class="label">Adresse mail</label>
            <div class="control">
                <input type="email" :class="email_error ? 'input is-danger is-rounded' : 'input is-rounded'" name="" id="" v-model="email">
            </div>
            <p class="help is-danger">{{email_error}}</p>
        </div>
        <div class="help">
            Pour vous connecter <span class="has-text-info is-clickable" @click="$emit('showSignIn')"> cliquez ici</span>
        </div>

        <div class="buttons mt-5 is-justify-content-center">
            <button id="btn-forgotten-pwd" class="button is-rounded is-info has-text-weight-bold" @click="send">
                Envoyer
            </button>
        </div>

    </section>
</template>

<script>
import axios from 'axios'
import { toast } from 'bulma-toast'
export default {
    name: 'ForgottenPassword',
    data () {
        return {
            email: null,
            email_error: null
        }
    },
    methods: {
        send () {
            const mail_reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!mail_reg.test(String(this.email).toLowerCase())) {
                this.email_error = "L'adresse mail est incorrecte."
                return false
            }
            this.email_error = null
            axios.post('/forgot-password', {email: this.email}).then(response => {
                toast({
                    message: 'Un mail a été envoyé à l\'adresse email indiquée afin de réinitialiser le mot de passe.',
                    type: 'is-success',
                    duration: 5000,
                    pauseOnHover: true
                })
            })
        }
    }
}
</script>

<style>
    #btn-forgotten-pwd {
        background-color: var(--btn-primary-bg-color);
        color: var(--btn-primary-text-color);
    }
    #btn-forgotten-pwd:hover {
        background-color: var(--btn-primary-bg-color-hover);
        color: var(--btn-primary-text-color);
    }
 </style>
